export default __webpack_public_path__ + "static/media/Bose.ba7a15e0.svg";